import Resource from '@/plugins/sdk/Resource'
import { UUID, ITEM } from '@/plugins/sdk/fields'
import Licensee from '@/plugins/sdk/resources/Licensee'

export default class extends Resource {
  static name = 'tenancy'

  static get fields () {
    return {
      id: new UUID(),
      licensee: new ITEM(Licensee)
    }
  }
}
